import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { NODE_UI, stopPropagation } from './nodeUiStyles';

/**
 * NodeSessionStatus — Session status display.
 * Used by: Await External Event.
 */

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: `${NODE_UI.spacing.sm} ${NODE_UI.spacing.md}`,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: NODE_UI.borderRadiusSm,
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.02)' : '#fafafa',
}));

const StatusText = styled(Typography)({
  fontSize: NODE_UI.fontSize.value,
  fontWeight: NODE_UI.fontWeight.label,
});

const DetailText = styled(Typography)(({ theme }) => ({
  fontSize: NODE_UI.fontSize.caption,
  color: theme.palette.text.secondary,
  marginLeft: 'auto',
}));

const STATUS_CONFIG = {
  active: { icon: CheckCircleOutlineIcon, color: 'success.main', label: 'Active' },
  waiting: { icon: HourglassEmptyIcon, color: 'warning.main', label: 'Waiting' },
  paused: { icon: PauseCircleOutlineIcon, color: 'text.secondary', label: 'Paused' },
  error: { icon: ErrorOutlineIcon, color: 'error.main', label: 'Error' },
  completed: { icon: CheckCircleOutlineIcon, color: 'success.main', label: 'Completed' },
};

const NodeSessionStatus = React.memo(function NodeSessionStatus({
  status = 'waiting',
  label,
  detail,
  sx,
}) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.waiting;
  const Icon = config.icon;

  return (
    <Root onMouseDown={stopPropagation} onClick={stopPropagation} onPointerDown={stopPropagation} sx={sx}>
      <Icon sx={{ fontSize: 18, color: config.color }} />
      <StatusText sx={{ color: config.color }}>
        {label || config.label}
      </StatusText>
      {detail && <DetailText>{detail}</DetailText>}
    </Root>
  );
});

export default NodeSessionStatus;
